 <template>

<v-card  class="ma-0 pa-0" style="width:100%; min-height:90vh ; background-color: #FAFAFA; box-shadow:none;">
  <v-layout row class=" primary pl-2 pr-2 " style="">
                          <v-flex  xs12 sm12 offset-sm2  class=" mr-3 ml-3 white hidden-md-and-up">
                              <h3 class="mb-1 text-xs-center" style="color:grey">  &nbsp; MANAGE GROUPS</h3>
                          </v-flex>
                      </v-layout>
                      <v-divider></v-divider>
  <v-container class="mt-2 pt-2" style=" min-height:40vh   ">
      
      <v-layout justify-center>
          <v-flex xs12 md10 offset-md1 class="ma-1 " >
              <v-form @submit.prevent="onCreateCollection" ref="form" >
                <v-layout elevation-1 class="white" style="box-shadow: 0 1px 5px rgba(0,0,0,0.2), 0 2px 2px rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12); min-height:40vh;" wrap>
                <v-flex xs12 md4 style="  border-right:1px solid #eeeeee  ">

                  <h3 class="hidden-sm-and-down pl-2 mb-0 pt-1 text-xs-center" style="color:grey; height:67px; font-size:2.3em">MANAGE GROUPS</h3>
                <div >
                  
                  <v-divider></v-divider>
                  <v-layout v-if="showOnSmallScreen()" row  class="mt-2  pl-2 pr-2 pt-2 pb-2 ">
                     

                  
                  <v-card v-if="preview == 0" style="box-shadow:none;">
                  
          <v-text-field append-icon="search" v-model="term" label="Find a group" hide-details  class="searchBar "></v-text-field>
                    <v-layout v-if="isNew(term.toUpperCase())" justify-center>
                        <v-btn @click="addNew(); isReallyOld = '3'; edit = false">Add New Group</v-btn>
                    </v-layout>
                    <v-list two-line>
          <template  >
            <div v-for="collection in methodResults" :key="collection._id" >
              <v-divider></v-divider>
            <v-list-tile avatar @click="preview = 1; isReallyOld='1' ; previewCollection=collection" class="pt-2 pb-0">
              <v-list-tile-avatar>
                <img :src="collection.imgUrl[0].url + '_profile'">
              </v-list-tile-avatar>
              <v-list-tile-content  class="collection-list-ie pt-1">
                <v-list-tile-title class="artTitle" v-html="collection.title[lang]"> </v-list-tile-title>
                <v-list-tile-sub-title  v-html=" collection.description[lang] "></v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>
            </div>
            
          </template>
        </v-list>
                  </v-card>

                  <v-card style="box-shadow:none;" v-if="preview == 1">

                    <v-btn block @click="preview = 0; isReallyOld='1'">
                      <v-icon left>arrow_back</v-icon> GO BACK
                    </v-btn>





                    <div class="pt-4 mt-4  pl-2 pr-2" style="width:100%" > 
            
        
            <v-layout row justify-center style="width:100%">
              <v-flex md12>
                  <v-layout justify-center class="pt-3">
                
                <v-btn  block class="grey lighten-2 ma-3" @click="editCollection(previewCollection._id); isReallyOld= '2';"><b>Edit Group</b></v-btn>
                <v-btn  block class="grey lighten-2 ma-3"  @click.native.stop="dialog = true"  ><b>Delete Group</b></v-btn>

                 <v-dialog v-model="dialog" max-width="290">
                            <v-card>
                                <v-card-text>Are you sure you want to delete this collection?</v-card-text>
                                <v-card-actions>
                                   <v-spacer></v-spacer>
                                 <v-btn color="primary" flat="flat" @click.native="dialog = false">No</v-btn>
                               <v-btn color="primary" flat="flat" @click="deleteGroup(selectedId)" >Yes</v-btn>
                             </v-card-actions>
                         </v-card>
                       </v-dialog>
                  </v-layout>
                

              </v-flex>
            </v-layout>

             <v-layout row wrap >
              
              <v-flex md12 class=" pl-4" style="position:relative; ">
                
                <p style="color:grey; position:relative; top:20%; margin:0px; white-space:nowrap;text-indent:20"><v-icon>view_day</v-icon> More in this Group</p>
              </v-flex>
              <v-spacer></v-spacer>

            </v-layout>

            <v-container class="artefact-list pl-0 pr-0">
        




           <v-list three-line>
          <template  >
          

            <div v-for="collection in collections" :key="collection._id" v-if="(collection.groups.indexOf(previewCollection.title.en) > -1)">

            <v-list-tile avatar @click="preview = 1; isReallyOld='1' ">
              <v-list-tile-avatar>
                <img :src="collection.imgUrl[0].url + '_profile'">
              </v-list-tile-avatar>
              <v-list-tile-content  class="collection-list-ie">
                <v-list-tile-title v-html="collection.title[lang]"> </v-list-tile-title>
                <v-list-tile-sub-title  v-html=" collection.description[lang] "></v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>
            </div>
            
          </template>
        </v-list>

            </v-container>

             </div>












                  </v-card>
                  
                  
                  
                  
                  
                  
                  
                  </v-layout>
                
                 
                
                      
                </div>





</v-flex>

<v-flex xs12 md8 style="position:relative">

<div class=" " style="height:100%;position:relative">

  <v-layout row class="hidden-sm-and-down pl-3 pt-3" style="height:67px;">
  <v-flex xs12>
  <p style="color:grey; font-size:1.1em"> <v-icon large>info </v-icon>  <i >Complete these fields to add/change the group: <span v-if="term && !preview">{{term}}</span> <span v-else-if="previewCollection.title[lang] && preview">{{previewCollection.title[lang]}}</span>  </i> </p>
    </v-flex> </v-layout>  <v-divider> </v-divider>
    
  
 <div class="" style="width:100%" v-if="(isReallyOld=='2' && edit == true)"> 
            <v-form @submit.prevent="onUpdateCollection(selectedId)" ref="form2">

              <!-- EDITARE PENTRU MOBIL -->

            <v-flex xs12 sm12 offset-sm2 class="hidden-md-and-up">
            <v-container class="pa-0 ma-0" style="position:relative; background-color:white" elevation-3>
              
            <v-flex class="pa-0 ma-0"  style="position:relative" sm12 xs12 offset-sm2 >
       
<v-toolbar color="primary" dark="dark">
          <v-toolbar-side-icon><v-icon>edit</v-icon></v-toolbar-side-icon>
          <v-toolbar-title>{{this.term}}</v-toolbar-title>
          <v-spacer></v-spacer>
          
        </v-toolbar>

            <v-container   class="pa-13 "  >

 <v-stepper non-linear>
      <v-stepper-header>
        <v-stepper-step step="En" editable >English</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="Ro" editable  >Romana</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="Sr" editable >Српски</v-stepper-step>
      </v-stepper-header> 

   <v-stepper-items>
      <v-stepper-content step="En">
      <keep-alive>

               <v-layout row wrap class="mt-2  p pt-2 pb-2 ">
                      <v-flex  class="text-xs-center mr-3 ml-3">
                           
                                 <v-btn style="width:215px;"
                                        color="primary"
                                        v-bind:class="{ 'green darken-3' : uploadEdit.status }"
                                        :loading="uploadEdit.loading"
                                        @click="clickInput2"
                                        >Update Primary Image
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                        
                                 </v-btn>
                  <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
                  <input type="file"  :name="uploadFieldName" :disabled="isSaving" @change="filesChangeEdit($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept="image/*" class="input-file" ref="fileInput2">
                  </form>
                         <img :src="uploadEdit.imgUrl[0].url" style="width:100%">
                      </v-flex>
                  

                      <v-flex xs12 sm10 offset-sm1 class="text-xs-center">
                          <v-text-field 
                          name="titleen"
                          label="Title"
                          id="titleen"
                        
                          v-model="uploadEdit.title.en"
                          :rules="titleRules"
                          >
                          </v-text-field>
                      </v-flex>

                      <v-flex xs12 sm10 offset-sm1 class="text-xs-center">
                          <v-text-field 
                          name="description"
                          label="Description"
                          id="description"
                          multi-line
                          v-model="uploadEdit.description.en"
                          :rules="descriptionRules"
                          >
                          </v-text-field>
                      </v-flex>
            
          


                  
               </v-layout>
                       </keep-alive>
      </v-stepper-content>


            <v-stepper-content step="Ro">
      <keep-alive>

               <v-layout row wrap class="mt-2  p pt-2 pb-2 ">
                      <v-flex  class="text-xs-center mr-3 ml-3">
                           
                                 <v-btn style="width:215px;"
                                        color="primary"
                                        v-bind:class="{ 'green darken-3' : uploadEdit.status }"
                                        :loading="uploadEdit.loading"
                                        @click="clickInput2"
                                        >Update Primary Image
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                        
                                 </v-btn>
                  <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
                  <input type="file"  :name="uploadFieldName" :disabled="isSaving" @change="filesChangeEdit($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept="image/*" class="input-file" ref="fileInput2">
                  </form>
                         <img :src="uploadEdit.imgUrl[0].url" style="width:100%">
                      </v-flex>
                  

                      <v-flex xs12 sm10 offset-sm1 class="text-xs-center">
                          <v-text-field 
                          name="titlero"
                          label="Title"
                          id="titlero"
                        
                          v-model="uploadEdit.title.ro"
                          :rules="titleRules"
                          >
                          </v-text-field>
                      </v-flex>

                      <v-flex xs12 sm10 offset-sm1 class="text-xs-center">
                          <v-text-field 
                          name="description"
                          label="Description"
                          id="description"
                          multi-line
                          v-model="uploadEdit.description.ro"
                          :rules="descriptionRules"
                          >
                          </v-text-field>
                      </v-flex>
            
          


                  
               </v-layout>
                       </keep-alive>
      </v-stepper-content>



            <v-stepper-content step="Sr">
      <keep-alive>

               <v-layout row wrap class="mt-2  p pt-2 pb-2 ">
                      <v-flex  class="text-xs-center mr-3 ml-3">
                           
                                 <v-btn style="width:215px;"
                                        color="primary"
                                        v-bind:class="{ 'green darken-3' : uploadEdit.status }"
                                        :loading="uploadEdit.loading"
                                        @click="clickInput2"
                                        >Update Primary Image
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                        
                                 </v-btn>
                  <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
                  <input type="file"  :name="uploadFieldName" :disabled="isSaving" @change="filesChangeEdit($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept="image/*" class="input-file" ref="fileInput2">
                  </form>
                         <img :src="uploadEdit.imgUrl[0].url" style="width:100%">
                      </v-flex>
                  

                      <v-flex xs12 sm10 offset-sm1 class="text-xs-center">
                          <v-text-field 
                          name="titlesr"
                          label="Title"
                          id="titlesr"
                        
                          v-model="uploadEdit.title.sr"
                          :rules="titleRules"
                          >
                          </v-text-field>
                      </v-flex>

                      <v-flex xs12 sm10 offset-sm1 class="text-xs-center">
                          <v-text-field 
                          name="description"
                          label="Description"
                          id="description"
                          multi-line
                          v-model="uploadEdit.description.sr"
                          :rules="descriptionRules"
                          >
                          </v-text-field>
                      </v-flex>
            
          

               

                  
               </v-layout>
                       </keep-alive>
      </v-stepper-content>

   </v-stepper-items>
    </v-stepper>


                  <v-layout>
                    <v-flex xs12 sm12 offset-sm1 class="text-xs-center">

          </v-flex>
                  </v-layout>


                  <v-layout justify-center v-if="uploadEdit.title.en.length > 0 && uploadEdit.title.ro.length > 0 && uploadEdit.title.sr.length > 0 && uploadEdit.description.en.length > 0 &&uploadEdit.description.ro.length > 0 &&uploadEdit.description.sr.length > 0 && uploadEdit.imgUrl[0]!= null" row>
             
                          <v-btn 
                          type = "submit"
                          color="primary"
                          @click="btnSubmit=!btnSubmit">Update Group
                          </v-btn>
                          <v-btn @click="preview = 0; isReallyOld='1'">
                      Cancel
                    </v-btn>
                  
                  </v-layout>

                  <v-layout v-else row justify-center>
             
                          <v-btn 
                          disabled>Update Group
                          </v-btn>
                   <v-btn @click="preview = 0; isReallyOld='1'">
                      Cancel
                    </v-btn>
                  </v-layout>

                  </v-container>

            </v-flex>

            </v-container>


            </v-flex>

            <!-- SFARSIT EDITARE PENTRU MOBIL -->











              <!-- EDITARE PENTRU DESKTOP -->
             <v-flex xs12 sm12   pb-4 class="hidden-sm-and-down">
            <v-container class="pa-0 ma-0" style="position:relative; background-color:white" >
            <v-flex class="pa-0 ma-0"  style="position:relative" sm12 xs12 offset-sm2 >
     



            <v-container   class=" "  >

              
                   


        
      <v-stepper non-linear>
      <v-stepper-header>
        <v-stepper-step step="En" editable >English</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="Ro" editable  >Romana</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="Sr" editable >Српски</v-stepper-step>
      </v-stepper-header> 

   <v-stepper-items>
      <v-stepper-content step="En">
      <keep-alive>
              <v-layout row wrap  class="mt-2 mb-2  white">
                              <v-flex xs12 sm10 offset-sm1 md12 offset-md0 class="text-xs-center">
                          <v-text-field 
                          name="titleen"
                          label="Title"
                          id="titleen"
                          
                          v-model="uploadEdit.title.en"
                          :rules="titleRules"
                          >
                          </v-text-field>
                      </v-flex>
                      <v-flex xs12 sm10 offset-sm1 md12 offset-md0 class="text-xs-center">
                          <v-text-field 
                          name="description"
                          label="Description"
                          id="description"
                          multi-line
                          v-model="uploadEdit.description.en"
                          :rules="descriptionRules"
                          >
                          </v-text-field>
                      </v-flex>
           

        


         
                      <v-flex  xs12 sm12  md12 offset-md0 class="text-xs-center ">
                           
                                 <v-btn style="width:100%; height:45px"
                                        color="primary"
                                        v-bind:class="{ 'green darken-3' : uploadEdit.status }"
                                        :loading="uploadEdit.loading"
                                       @click="clickInput2"
                                        >Update Primary Image
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
                  <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
                  <input type="file"  :name="uploadFieldName" :disabled="isSaving" @change="filesChangeEdit($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept="image/*" class="input-file" ref="fileInput2">
                  </form>
                         <img :src="uploadEdit.imgUrl[0].url" style="width:100%">
                      </v-flex>
                  </v-layout>
   </keep-alive>
      </v-stepper-content>

            <v-stepper-content step="Ro">
      <keep-alive>
                          <v-layout row wrap  class="mt-2 mb-2  white">
                                                          <v-flex xs12 sm10 offset-sm1 md12 offset-md0 class="text-xs-center">
                          <v-text-field 
                          name="titlero"
                          label="Title"
                          id="titlero"
                          
                          v-model="uploadEdit.title.ro"
                          :rules="titleRules"
                          >
                          </v-text-field>
                      </v-flex>
                      <v-flex xs12 sm10 offset-sm1 md12 offset-md0 class="text-xs-center">
                          <v-text-field 
                          name="description"
                          label="Description"
                          id="description"
                          multi-line
                          v-model="uploadEdit.description.ro"
                          :rules="descriptionRules"
                          >
                          </v-text-field>
                      </v-flex>
           
 


         
                      <v-flex  xs12 sm12  md12 offset-md0 class="text-xs-center ">
                           
                                 <v-btn style="width:100%; height:45px"
                                        color="primary"
                                        v-bind:class="{ 'green darken-3' : uploadEdit.status }"
                                        :loading="uploadEdit.loading"
                                       @click="clickInput2"
                                        >Update Primary Image
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
                  <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
                  <input type="file"  :name="uploadFieldName" :disabled="isSaving" @change="filesChangeEdit($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept="image/*" class="input-file" ref="fileInput2">
                  </form>
                         <img :src="uploadEdit.imgUrl[0].url" style="width:100%">
                      </v-flex>
                  </v-layout>
   </keep-alive>
      </v-stepper-content>

                  <v-stepper-content step="Sr">
      <keep-alive>
                          <v-layout row wrap  class="mt-2 mb-2  white">
                                                          <v-flex xs12 sm10 offset-sm1 md12 offset-md0 class="text-xs-center">
                          <v-text-field 
                          name="titlesr"
                          label="Title"
                          id="titlesr"
                          
                          v-model="uploadEdit.title.sr"
                          :rules="titleRules"
                          >
                          </v-text-field>
                      </v-flex>
                      <v-flex xs12 sm10 offset-sm1 md12 offset-md0 class="text-xs-center">
                          <v-text-field 
                          name="description"
                          label="Description"
                          id="description"
                          multi-line
                          v-model="uploadEdit.description.sr"
                          :rules="descriptionRules"
                          >
                          </v-text-field>
                      </v-flex>
           



         
                      <v-flex  xs12 sm12  md12 offset-md0 class="text-xs-center ">
                           
                                 <v-btn style="width:100%; height:45px"
                                        color="primary"
                                        v-bind:class="{ 'green darken-3' : uploadEdit.status }"
                                        :loading="uploadEdit.loading"
                                       @click="clickInput2"
                                        >Update Primary Image
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
                  <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
                  <input type="file"  :name="uploadFieldName" :disabled="isSaving" @change="filesChangeEdit($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept="image/*" class="input-file" ref="fileInput2">
                  </form>
                         <img :src="uploadEdit.imgUrl[0].url" style="width:100%">
                      </v-flex>
                  </v-layout>
   </keep-alive>
      </v-stepper-content>

   </v-stepper-items>

     </v-stepper>
         
         


                  </v-container>

            </v-flex>

            </v-container>


            </v-flex>

            




 <v-btn class="hidden-sm-and-down" v-if="uploadEdit.title.en.length > 0 && uploadEdit.title.ro.length > 0 && uploadEdit.title.sr.length > 0 && uploadEdit.description.en.length > 0 &&uploadEdit.description.ro.length > 0 &&uploadEdit.description.sr.length > 0 && uploadEdit.imgUrl[0]!= null"
              color="red darken-1"
              dark
              medium
              fixed
              bottom
              right
              fab
              v-model="fab"
        type = "submit"
        @click="btnSubmit=!btnSubmit"
            >
              <v-icon>save</v-icon>
            </v-btn>

            <v-btn class="hidden-sm-and-down" v-else  color="grey" @click.native="snackbar = true" dark
              medium
              fixed
              bottom
              right
              fab><v-icon>save</v-icon></v-btn>


            <v-snackbar
      :timeout="timeout"
      color="red"
      :multi-line="mode === 'multi-line'"
      :vertical="mode === 'vertical'"
      v-model="snackbar"
    >
      All fields must be completed
      <v-btn dark flat @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  
<!-- SFARSIT EDITARE PENTRU DESKTOP -->






            </v-form>
            <!-- SFARSIT EDITARE -->



             </div>
                
                  <div  class=" "  style="width:100%" v-if="(isReallyOld=='3') && this.edit==false">
            <v-form @submit.prevent="onCreateCollection" ref="form">

              <!-- ADAUGARE NOU PENTRU MOBIL -->
            <v-flex xs12 sm12 offset-sm2 md10 offset-md1 pb-4 class="hidden-md-and-up">
            
            <v-container class="pa-0 ma-0" style="position:relative; background-color:white" elevation-3>
              
            <v-flex class="pa-0 ma-0"  style="position:relative" sm12 xs12 offset-sm2 >
     


            <v-toolbar color="primary" dark="dark">
          <v-toolbar-side-icon><v-icon>add_circle</v-icon></v-toolbar-side-icon>
          <v-toolbar-title>{{this.term}}</v-toolbar-title>
          <v-spacer></v-spacer>
          
        </v-toolbar>

            <v-container   class=" "  >

     <v-stepper non-linear>
      <v-stepper-header>
        <v-stepper-step step="En" editable >English</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="Ro" editable  >Romana</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="Sr" editable >Српски</v-stepper-step>
      </v-stepper-header> 

   <v-stepper-items>
      <v-stepper-content step="En">
      <keep-alive>

               <v-layout row wrap class="mt-2  p pt-2 pb-2 ">
                      <v-flex  class="text-xs-center mr-3 ml-3">
                           
                                 <v-btn style="width:215px;"
                                        color="primary"
                                        v-bind:class="{ 'green darken-3' : uploadAdd.status }"
                                        :loading="uploadAdd.loading"
                                        @click="clickInput2"
                                        >Update Primary Image
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                        
                                 </v-btn>
                  <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
                  <input type="file"  :name="uploadFieldName" :disabled="isSaving" @change="filesChangeAdd($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept="image/*" class="input-file" ref="fileInput2">
                  </form>
                         <img :src="uploadAdd.imgUrl[0].url" style="width:100%">
                      </v-flex>
                  

                      <v-flex xs12 sm10 offset-sm1 class="text-xs-center">
                          <v-text-field 
                          name="titleen"
                          label="Title"
                          id="titleen"
                        
                          v-model="uploadAdd.title.en"
                          :rules="titleRules"
                          >
                          </v-text-field>
                      </v-flex>

                      <v-flex xs12 sm10 offset-sm1 class="text-xs-center">
                          <v-text-field 
                          name="description"
                          label="Description"
                          id="description"
                          multi-line
                          v-model="uploadAdd.description.en"
                          :rules="descriptionRules"
                          >
                          </v-text-field>
                      </v-flex>
            
          

        
                  
               </v-layout>
                       </keep-alive>
      </v-stepper-content>


            <v-stepper-content step="Ro">
      <keep-alive>

               <v-layout row wrap class="mt-2  p pt-2 pb-2 ">
                      <v-flex  class="text-xs-center mr-3 ml-3">
                           
                                 <v-btn style="width:215px;"
                                        color="primary"
                                        v-bind:class="{ 'green darken-3' : uploadAdd.status }"
                                        :loading="uploadAdd.loading"
                                        @click="clickInput2"
                                        >Update Primary Image
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                        
                                 </v-btn>
                  <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
                  <input type="file"  :name="uploadFieldName" :disabled="isSaving" @change="filesChangeAdd($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept="image/*" class="input-file" ref="fileInput2">
                  </form>
                         <img :src="uploadAdd.imgUrl[0].url" style="width:100%">
                      </v-flex>
                  

                      <v-flex xs12 sm10 offset-sm1 class="text-xs-center">
                          <v-text-field 
                          name="titlero"
                          label="Title"
                          id="titlero"
                        
                          v-model="uploadAdd.title.ro"
                          :rules="titleRules"
                          >
                          </v-text-field>
                      </v-flex>

                      <v-flex xs12 sm10 offset-sm1 class="text-xs-center">
                          <v-text-field 
                          name="description"
                          label="Description"
                          id="description"
                          multi-line
                          v-model="uploadAdd.description.ro"
                          :rules="descriptionRules"
                          >
                          </v-text-field>
                      </v-flex>
            
          

               
   
                  
               </v-layout>
                       </keep-alive>
      </v-stepper-content>



            <v-stepper-content step="Sr">
      <keep-alive>

               <v-layout row wrap class="mt-2  p pt-2 pb-2 ">
                      <v-flex  class="text-xs-center mr-3 ml-3">
                           
                                 <v-btn style="width:215px;"
                                        color="primary"
                                        v-bind:class="{ 'green darken-3' : uploadAdd.status }"
                                        :loading="uploadAdd.loading"
                                        @click="clickInput2"
                                        >Update Primary Image
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                        
                                 </v-btn>
                  <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
                  <input type="file"  :name="uploadFieldName" :disabled="isSaving" @change="filesChangeAdd($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept="image/*" class="input-file" ref="fileInput2">
                  </form>
                         <img :src="uploadAdd.imgUrl[0].url" style="width:100%">
                      </v-flex>
                  

                      <v-flex xs12 sm10 offset-sm1 class="text-xs-center">
                          <v-text-field 
                          name="titlero"
                          label="Title"
                          id="titlero"
                        
                          v-model="uploadAdd.title.sr"
                          :rules="titleRules"
                          >
                          </v-text-field>
                      </v-flex>

                      <v-flex xs12 sm10 offset-sm1 class="text-xs-center">
                          <v-text-field 
                          name="description"
                          label="Description"
                          id="description"
                          multi-line
                          v-model="uploadAdd.description.sr"
                          :rules="descriptionRules"
                          >
                          </v-text-field>
                      </v-flex>
            
          

               
 
                  
               </v-layout>
                       </keep-alive>
      </v-stepper-content>

   </v-stepper-items>
    </v-stepper>



                  <v-layout justify-center v-if="uploadAdd.title.en.length > 0 && uploadAdd.title.ro.length > 0 && uploadAdd.title.sr.length > 0 && uploadAdd.description.en.length > 0 &&uploadAdd.description.ro.length > 0 &&uploadAdd.description.sr.length > 0 && uploadAdd.imgUrl[0]!= null" row>
                   
                          <v-btn 
                          type = "submit"
                          color="primary"
                          @click="btnSubmit=!btnSubmit">Add Group
                          </v-btn>
                          <v-btn @click="preview = 0; isReallyOld='1'">
                      Cancel
                    </v-btn>
                
                  </v-layout>

                  <v-layout justify-center v-else row>
                     
                          <v-btn 
                          disabled>Add Group
                          </v-btn>
                          <v-btn @click="preview = 0; isReallyOld='1'">
                      Cancel
                    </v-btn>
                     
                  </v-layout>

                  </v-container>

            </v-flex>

            </v-container>


            </v-flex>

            <!-- SFARSIT ADAUGARE NOU PENTRU MOBIL -->
















            <!--  ADAUGARE NOU PENTRU DESKTOP -->

            <v-flex xs12 sm12   pb-4 class="hidden-sm-and-down" v-if="term">
            <v-container class="pa-0 ma-0" style="position:relative; background-color:white" >
            <v-flex class="pa-0 ma-0"  style="position:relative" sm12 xs12 offset-sm2 >
   



            <v-container   class=" "  >

              
                  


       <v-stepper non-linear>
      <v-stepper-header>
        <v-stepper-step step="En" editable >English</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="Ro" editable  >Romana</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="Sr" editable >Српски</v-stepper-step>
      </v-stepper-header> 

   <v-stepper-items>
      <v-stepper-content step="En">
      <keep-alive>
              <v-layout row wrap  class="mt-2 mb-2  white">

              <v-flex xs12 sm10 offset-sm1 md12 offset-md0 class="text-xs-center">
                          <v-text-field 
                          name="titleen"
                          label="Title"
                          id="titleen"
                          
                          v-model="uploadAdd.title.en"
                          :rules="titleRules"
                          >
                          </v-text-field>
                      </v-flex>

                      <v-flex xs12 sm10 offset-sm1 md12 offset-md0 class="text-xs-center">
                          <v-text-field 
                          name="description"
                          label="Description"
                          id="description"
                          multi-line
                          v-model="uploadAdd.description.en"
                          :rules="descriptionRules"
                          >
                          </v-text-field>
                      </v-flex>

        


         
                      <v-flex  xs12 sm12  md12 offset-md0 class="text-xs-center ">
                           
                                 <v-btn style="width:100%; height:45px"
                                        color="primary"
                                        v-bind:class="{ 'green darken-3' : uploadAdd.status }"
                                        :loading="uploadAdd.loading"
                                       @click="clickInput2"
                                        >Update Primary Image
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
                  <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
                  <input type="file"  :name="uploadFieldName" :disabled="isSaving" @change="filesChangeAdd($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept="image/*" class="input-file" ref="fileInput2">
                  </form>
                         <img :src="uploadAdd.imgUrl[0].url" style="width:100%">
                      </v-flex>
                  </v-layout>
   </keep-alive>
      </v-stepper-content>

            <v-stepper-content step="Ro">
      <keep-alive>
                          <v-layout row wrap  class="mt-2 mb-2  white">
                    <v-flex xs12 sm10 offset-sm1 md12 offset-md0 class="text-xs-center">
                          <v-text-field 
                          name="titlero"
                          label="Title"
                          id="titlero"
                         
                          v-model="uploadAdd.title.ro"
                          :rules="titleRules"
                          >
                          </v-text-field>
                      </v-flex>

                      <v-flex xs12 sm10 offset-sm1 md12 offset-md0 class="text-xs-center">
                          <v-text-field 
                          name="description"
                          label="Description"
                          id="description"
                          multi-line
                          v-model="uploadAdd.description.ro"
                          :rules="descriptionRules"
                          >
                          </v-text-field>
                      </v-flex>
           

        


         
                      <v-flex  xs12 sm12  md12 offset-md0 class="text-xs-center ">
                           
                                 <v-btn style="width:100%; height:45px"
                                        color="primary"
                                        v-bind:class="{ 'green darken-3' : uploadAdd.status }"
                                        :loading="uploadAdd.loading"
                                       @click="clickInput2"
                                        >Update Primary Image
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
                  <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
                  <input type="file"  :name="uploadFieldName" :disabled="isSaving" @change="filesChangeAdd($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept="image/*" class="input-file" ref="fileInput2">
                  </form>
                         <img :src="uploadAdd.imgUrl[0].url" style="width:100%">
                      </v-flex>
                  </v-layout>
   </keep-alive>
      </v-stepper-content>

                  <v-stepper-content step="Sr">
      <keep-alive>
                          <v-layout row wrap  class="mt-2 mb-2  white">
                      <v-flex xs12 sm10 offset-sm1 md12 offset-md0 class="text-xs-center">

                    <v-flex xs12 sm10 offset-sm1 md12 offset-md0 class="text-xs-center">
                          <v-text-field 
                          name="titlesr"
                          label="Title"
                          id="titlesr"
                      
                          v-model="uploadAdd.title.sr"
                          :rules="titleRules"
                          >
                          </v-text-field>
                      </v-flex>

                          <v-text-field 
                          name="description"
                          label="Description"
                          id="description"
                          multi-line
                          v-model="uploadAdd.description.sr"
                          :rules="descriptionRules"
                          >
                          </v-text-field>
                      </v-flex>
           

        


         
                      <v-flex  xs12 sm12  md12 offset-md0 class="text-xs-center ">
                           
                                 <v-btn style="width:100%; height:45px"
                                        color="primary"
                                        v-bind:class="{ 'green darken-3' : uploadAdd.status }"
                                        :loading="uploadAdd.loading"
                                       @click="clickInput2"
                                        >Update Primary Image
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
                  <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
                  <input type="file"  :name="uploadFieldName" :disabled="isSaving" @change="filesChangeAdd($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept="image/*" class="input-file" ref="fileInput2">
                  </form>
                         <img :src="uploadAdd.imgUrl[0].url" style="width:100%">
                      </v-flex>
                  </v-layout>
   </keep-alive>
      </v-stepper-content>

   </v-stepper-items>

     </v-stepper>
         

                   

                  </v-container>

            </v-flex>

            </v-container>


            </v-flex>



     <v-btn class="hidden-sm-and-down" v-if="uploadAdd.title.en.length > 0 && uploadAdd.title.ro.length > 0 && uploadAdd.title.sr.length > 0 && uploadAdd.description.en.length > 0 &&uploadAdd.description.ro.length > 0 &&uploadAdd.description.sr.length > 0 && uploadAdd.imgUrl[0]!= null"
              color="red darken-1"
              dark
              medium
              fixed
              bottom
              right
              fab
              v-model="fab"
        type = "submit"
        @click="btnSubmit=!btnSubmit"
            >
              <v-icon>save</v-icon>
            </v-btn>

            <v-btn class="hidden-sm-and-down" v-else  color="grey" @click.native="snackbar = true" dark
              medium
              fixed
              bottom
              right
              fab><v-icon>save</v-icon></v-btn>


            <v-snackbar
      :timeout="timeout"
      color="red"
      :multi-line="mode === 'multi-line'"
      :vertical="mode === 'vertical'"
      v-model="snackbar"
    >
      All fields must be completed
      <v-btn dark flat @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>



    <!-- SFARSIT ADAUGARE NOU PENTRU DESKTOP -->

            </v-form>
             </div>







     




                  </div>

                 
                  
                  </v-flex>
                  </v-layout>

                 
             
              </v-form>
              
           
          </v-flex>
      </v-layout>
       <div class="container">

  </div>
  </v-container>
 </v-card>
</template>













<script>
import { upload } from "@/components/FileUpload/file-upload.service";
import axios from "axios";
const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;

export default {
  data() {
    return {
      direction: "left",
      preview:0,
            previewCollection:{ 
        title: {
          en:"",
          ro:"",
          sr:""
        }
      },
      methodResults: [],
      term: "",
      defaultAllToggle: false,
      options: {
        keys: ["title"]
      },
      fab: false,
       snackbar: false,
        y: 'top',
        x: null,
        mode: '',
        timeout: 6000,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      snackbar:'',
      timeout:6000,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",
      edit: false,
      dialog:false,
      uploadAdd: {
        title: {
          en:"",
          ro:"",
          sr:""
        },
        description:  {
          en:"",
          ro:"",
          sr:""
        },
        imgUrl: [
          {url:""}
        ],
        location: {},
        meta: {
          title: "",
          author: "",
          location: "",
          type: "",
          copyright: "",
          license: "",
          conentType: ""
        },
        adminId: "1",
        status : 0,
        loading: false

      },
      uploadEdit: {
        title: {
          en:"",
          ro:"",
          sr:""
        },
        description: {
          en:"",
          ro:"",
          sr:""
        },
        imgUrl: [{url:""}],
        location: {},
        meta: {
          title: "",
          author: "",
          location: "",
          type: "",
          copyright: "",
          license: "",
          conentType: ""
        },
        adminId: "1",
        status : 0,
        loading: 0

      },
      uploadError: null,
      currentStatus: null,
      uploadFieldName: "photos",
      select: null,
      isReallyOld: '1',
      description: "",
      e6: [],
      e7: [],
      keyMessage: "",
      states: ["Timisoara", "Romania Culture"],
      activePlus: false,
      descriptionRules: [(v) => !!v || 'Description is required'],
      titleRules: [(v) => !!v || 'Title is required']
    };
  },
  
  computed: {
    lang() {
      return this.$store.getters.loadLang
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    collections() {
      return this.$store.getters.loadAllCollections;
    },
    items() {
      return this.$store.getters.loadGroups;
      
    },
    artefacts() {
      return this.$store.getters.loadArtefacts;
    },
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
    // collections() {
    //     return  this.$store.getters.loadAllCollections; 
    // },
    selectedId() {
    
        var i;
        for (i = 0; i < this.items.length; i++) {
          console.log(this.items);
          if (this.items[i].title === this.previewCollection.title) return this.items[i]._id;
         
       
      }
    },
    users() {
      return this.$store.getters.loadUsers;
    },
  },
   watch: {
    term() {
      
      this.$search(this.term, this.items, this.options).then(results => {
        this.methodResults = results;
        if (this.term == "") {
          this.methodResults = this.items;
        }
      });
    },
  },
  methods: {
    showOnSmallScreen() { 
      return (this.isReallyOld == 1) || (window.innerWidth > 950);
    },
    toArtefact(artefactID) {
        this.$router.push('/artefacts/'+artefactID);
        
      },
    minimize(str, spaces) {
      if (str.split(" ").length < spaces) return str;
      else
        return (
          str
            .split(" ")
            .slice(0, spaces - 1)
            .join(" ") + "..."
        );
    },
    clickInputMain() {
      this.$refs.fileInput1.click();
    },
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    saveAdd(formData) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING;
      this.uploadAdd.loading = 1;
      upload(formData)
        .then(x => {
          this.uploadAdd.loading = 0;
          this.uploadAdd.status = 1;
          this.uploadAdd.imgUrl = x;
          this.currentStatus = STATUS_SUCCESS;
        })
        .catch(err => {
          this.uploadAdd.loading = 0;
          this.uploadError = err.response;
          this.currentStatus = STATUS_FAILED;
        });
    },
    filesChangeAdd(fieldName, fileList) {
      // handle file changes
      const formData = new FormData();

      if (!fileList.length) return;

      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map(x => {
        formData.append(fieldName, fileList[x], fileList[x].name);
      });
      // save it
      this.saveAdd(formData);
    },
    saveEdit(formData) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING;
      this.uploadEdit.loading = 1;
      upload(formData)
        .then(x => {
           this.uploadEdit.loading = 0;
            this.uploadEdit.status = 1;
          this.uploadEdit.imgUrl = x;
          this.currentStatus = STATUS_SUCCESS;
        })
        .catch(err => {
          this.uploadError = err.response;
          this.currentStatus = STATUS_FAILED;
        });
    },
    filesChangeEdit(fieldName, fileList) {
      // handle file changes
      const formData = new FormData();

      if (!fileList.length) return;

      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map(x => {
        formData.append(fieldName, fileList[x], fileList[x].name);
      });
      // save it
      this.saveEdit(formData);
    },
    onCreateCollection() {
      this.$store.dispatch("createGroup", this.uploadAdd).then(response => {
             this.$router.push('/groups/'+response.data._id);

        }, error => {
        })
    },
    onUpdateCollection(idval) {
      this.$store.dispatch("updateGroup", this.uploadEdit);
      this.$router.push({ path: "/groups/"+this.uploadEdit._id });
    },
    deleteGroup: function(idval) {
    this.$store.dispatch("deleteGroup" ,{ _id:idval}).then(
        response => {
          this.$store.dispatch("loadGroups");
          this.dialog = false;
          this.$router.push("/settings/");
        },
        err => {
          console.log(err);
        }
      );
    },
    editCollection: function(idval) {
      this.edit = true;
      var i = 0;
      for (i = 0; i < this.items.length; i++)
        if (this.items[i]._id == idval) this.uploadEdit = this.items[i];
    },
    clickInput2() {
      this.$refs.fileInput2.click();
    },
    clickInput1() {
      this.$refs.fileInput1.click();
    },
    addNew () {

      this.isReallyOld = '3';
      this.uploadAdd.title.en = this.term;
      this.uploadAdd.title.sr = this.term;
      this.uploadAdd.title.ro = this.term;
      this.uploadAdd.description.en = '';
      this.uploadAdd.description.sr = '';
      this.uploadAdd.description.ro = '';
      this.edit = false;

    },
    isNew (val) {
        if (val) {
        var i = 0;
        var k = 0;
        for (i = 0; i < this.items.length; i++) {
          if (this.items[i].title[this.lang].toUpperCase() == val) {
            k++;
          }
        }
        if (k > 0) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
  },
  mounted() {
     document.title = "Manage Groups";
    window.scrollTo(0, 0);
    this.reset();
    this.$store.dispatch("loadCollections");
     this.$store.dispatch("loadUsers");
    this.$store.dispatch("loadArtefacts");
    this.methodResults = this.items;
    
  },
  created() {
    if (!this.isAdmin && !this.isLoggedIn) this.$router.push("/signin");
    else if (!this.isAdmin && this.isLoggedIn) this.$router.push("/");
  },
 
};
</script>















<style>
.artTitle{
  font-weight:600;
}

.input-file
{
display: none;
}
.map {
  position: relative;
}

.map-toolbar {
  position: absolute;
  width: 80%;
}

.toolbar__content {
    position: relative;
    width: 100%;
}
</style>




<style scoped>

.collection-list-ie {
      display: inline;
    }

.noBoxShadow { 
  box-shadow: none;
}

.listOfArtefacts {
  background-color:white;

}

.listOfArtefacts:hover {
  background-color:#efefef;
  cursor:pointer;
  
}

.searchBar { 
  /* padding-top:0px; */

   text-indent:20px; 
  padding-bottom:15px;
  padding-left:20px;
  padding-right:20px;
  
}
</style>


// WEBPACK FOOTER //
// src/components/Administration/Groups/ManageGroups.vue